import { createContext } from 'use-context-selector'
import { AcceptInviteContextProps } from './types'

export const AcceptInviteContext = createContext({} as AcceptInviteContextProps)
